<ejs-dialog #directoryPermissionsDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="onCancel()">
  <ng-template #header>
    {{'i18n.domain.assets.asset-storage-permissions.dialog.title' | translate}}
  </ng-template>

  <ng-template #content>
    <div class="form-row row">
      <div class="col-12">
        <ejs-grid #grid class="grid-with-toolbar" width="100%" rowHeight="38"
          [dataSource]="allMergdeDirectoryPermissions" [allowSorting]="false" [allowFiltering]="false"
          [allowPaging]="false" [editSettings]="customEditSettings">
          <e-columns>
            <e-column field="groupName"
              headerText="{{'i18n.domain.assets.asset-storage-permissions.grid.column-headers.name' | translate}}"
              clipMode="EllipsisWithTooltip">
              <ng-template #template let-data>
                <span>{{getGroupName(data.groupId)}}</span>
              </ng-template>
            </e-column>
            <e-column
              headerText="{{'i18n.domain.assets.asset-storage-permissions.grid.column-headers.read' | translate}}"
              width='100px'>
              <ng-template #template let-data>
                <input type="checkbox" [(ngModel)]="data.read" (change)="permissionChange($event, data, 'read')" />
              </ng-template>
            </e-column>
            @if(!isLimitedAdmin){
              <e-column headerText="{{'i18n.domain.assets.asset-storage-permissions.grid.column-headers.write' | translate}}" width='150px'>
                <ng-template #template let-data>
                  <input type="checkbox" [(ngModel)]="data.write" (change)="permissionChange($event, data, 'write')" />
                </ng-template>
              </e-column>
            }
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-flat" (click)="onCancel()">
        {{'i18n.shared.cancel' | translate}}
      </button>
      <button class="e-control e-btn e-lib e-primary e-flat" (click)="onSave()" [disabled]="isSaveDisabled">
        {{'i18n.shared.save' | translate}}
      </button>
    </ng-container>
  </ng-template>
</ejs-dialog>
